module.exports = __webpack_public_path__ + "static/media/__message.4eff59a9.svg";